import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { ARC, PixelIcon } from '@/components/generals/arcade'
import { ABOUT } from '@/components/landing/about/data'

/* the continue screen at the end of the run */
const Continue: FC = (): ReactNode => {
    const { cta } = ABOUT

    return (
        <section id='start' className={ARC.section} aria-labelledby='start-title'>
            <div
                className={cn(
                    'relative isolate overflow-hidden bg-(--cab-cream) px-6 py-14 text-center text-(--cab-plum) md:px-16 md:py-24',
                    'rounded-[clamp(20px,3.4vw,48px)] shadow-[0_0_0_10px_#34495a,0_0_0_14px_rgba(0,0,0,0.18),0_30px_60px_-20px_rgba(0,0,0,0.45)]'
                )}
            >
                <div className='cab-scan' aria-hidden />
                <div className='cab-glass' aria-hidden />

                <div className='relative z-10 flex flex-col items-center gap-5'>
                    <p className={cn(ARC.pixel, 'cab-blink m-0 text-sm tracking-[0.16em]')}>{cta.kicker}</p>
                    <h2 id='start-title' className={cn(ARC.outline, 'm-0 text-3xl leading-tight text-balance sm:text-5xl lg:text-6xl')}>
                        {cta.title}
                    </h2>
                    <p className={cn(ARC.text, 'max-w-[54ch]')}>{cta.body}</p>

                    <div className='flex flex-wrap items-center justify-center gap-6 pt-2 pb-2'>
                        <Link href={cta.primary.href} className={cn(ARC.btn, ARC.btnPrimary)}>
                            {cta.primary.label}
                            <PixelIcon name='right' className={ARC.glyph} />
                        </Link>
                        <Link href={cta.secondary.href} className={ARC.btn}>
                            {cta.secondary.label}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Continue
